export default __webpack_public_path__ + "static/media/pills.16b7f6b7.png";